import React, { useEffect, useState } from 'react'
import { SearchOutlined } from '@ant-design/icons'
import { debounce } from 'lodash'
import { useSearchOrganization } from 'api/search/search'
import Spinner from 'components/Spinner'
import { Avatar, Checkbox } from 'antd'
import { getNameSignature } from 'helper/utility'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import { leagueInvitationStore } from 'state/league/leagueInvitation'

const InviteOrgContent: React.FC = () => {
  const { selectedOrgsIds, setSelectedOrgsIds } = leagueInvitationStore(
    store => ({
      selectedOrgsIds: store.selectedOrgsIds,
      setSelectedOrgsIds: store.setSelectedOrgsIds,
    }),
  )
  const [params, setParams] = useState<{ queryString: string }>({
    queryString: '',
  })
  const {
    data: orgLists,
    isLoading: orgListLoading,
    isFetching: orgListFetching,
    refetch: orgListRefetch,
  } = useSearchOrganization(params)

  const handleSearchChange = (e: string) => {
    setParams(prev => ({ ...prev, queryString: e }))
  }
  const debounced = debounce(handleSearchChange, 800)
  const handleChange = (e: string[]) => {
    setSelectedOrgsIds(e)
  }

  useEffect(() => {
    if (params.queryString.length > 0) {
      orgListRefetch()
    }
  }, [params])

  return (
    <>
      <p>Select organizations that will jointly organize the league</p>
      <div className="search-input-box mt-16px">
        <input
          type="search"
          className="search-input-group"
          placeholder="Search"
          onChange={e => {
            e.preventDefault()
            debounced(e.target.value)
          }}
        />
        <SearchOutlined />
      </div>
      <div className="mt-20px">
        {params.queryString.length === 0 ? (
          <p className="text-center mt-16px">Search organizations</p>
        ) : orgListLoading || orgListFetching ? (
          <div className="py-40px">
            <Spinner />
          </div>
        ) : orgLists.length > 0 ? (
          <Checkbox.Group
            className="d-flex flex flex-column flex-wrap gap-16px listings"
            onChange={handleChange}
            value={selectedOrgsIds}
          >
            {orgLists.map(org => {
              return (
                <Checkbox
                  value={org._id}
                  key={org._id}
                  className="checkbox-style"
                >
                  <div className="flex align-center gap-16px">
                    <Avatar size={40} src={org.photo?.post}>
                      {getNameSignature(`${org.name}`)}
                    </Avatar>
                    <h4 className="w-500 text-16">{org.name}</h4>
                  </div>
                </Checkbox>
              )
            })}
          </Checkbox.Group>
        ) : (
          <p className="text-center mt-16px">
            {params.queryString.trim().length > 0 ? 'No organizations' : ''}
          </p>
        )}
      </div>
    </>
  )
}

export default InviteOrgContent
